export const comments_3257604 = {"data":{"data":[],"links":{}}}